import { Component } from 'react'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import { connect } from 'react-redux'
import {
  productClickViewDetails,
  mapOfferInfoClick,
} from 'actions/AnalyticsActions'
import MultipleMarkers from 'components/Common/PropertyMap/MultipleMarkers'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import Carousel from './Carousel'
import TextButton from 'LuxKit/Button/TextButton'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const StyledGrid = styled(LayoutContainer)`
  .slider-frame {
    margin: 0 ${rem(30)} !important; /* need to override carousel inline styles :(  */
  }
`

const CenterSpacing = styled.div`
  text-align: center;
`

interface Props {
  filters: App.OfferListFilters
  offers: Array<App.Offer | App.OfferSummary>
  markers?: Array<App.MapMarker>
  loaded: boolean
  showCarousel?: boolean
  onProductClick?: () => void
  mapOfferInfoClick: (offer: App.Offer) => void
  productClickViewDetails: (offer: App.Offer) => void
}

class OfferMap extends Component<React.PropsWithChildren<Props>> {
  elements = {
    map: React.createRef<any>(),
    carousel: React.createRef<any>(),
  }

  onSelectPropertyMarker = (marker: App.MapMarker) => {
    if (this.elements.carousel.current && marker.propertyItem) {
      this.elements.carousel.current.goToSlideForOffer(marker.propertyItem.offerId)
    }
  }

  onSlideChange = (offerId: string) => {
    this.elements.map.current.focusProperty(offerId)
  }

  render() {
    const {
      offers,
      loaded,
      markers,
      showCarousel,
    } = this.props

    return <>
      <MultipleMarkers
        ref={this.elements.map}
        offers={offers}
        markers={markers}
        height="535px"
        onSelectPropertyMarker={this.onSelectPropertyMarker}
        loaded={loaded}
        mapOptions={{
          scrollwheel: false,
        }}
      />

      {loaded && showCarousel &&
        <Pane padding="40 0">
          <StyledGrid>
            <VerticalSpacer gap={32}>
              <Carousel
                ref={this.elements.carousel}
                offers={offers}
                onSlideChange={this.onSlideChange}
              />
              <CenterSpacing>
                <TextButton kind="primary" to="/" fit="mobile-full-width"><FormattedMessage id="NTcKZYKyvUuTyIuEPStN" defaultMessage="View all escapes" description="Button to view all available escapes from the offer map section" /></TextButton>
              </CenterSpacing>
            </VerticalSpacer>
          </StyledGrid>
        </Pane>}
    </>
  }
}

const mapDispatchToProps = {
  productClickViewDetails,
  mapOfferInfoClick,
}

export default connect(null, mapDispatchToProps)(OfferMap)
